module.exports = __webpack_public_path__ + "img/ET.bc157b44.svg";